import * as React from 'react';
import { Link } from 'react-router-dom';
/**
 * A single breadcrumb to be used in a breadcrumb container.
 */
export var BreadcrumbItem = function (_a) {
    var current = _a.current, path = _a.path, children = _a.children;
    if (current) {
        return React.createElement("li", null, children);
    }
    else {
        return (React.createElement("li", null,
            React.createElement(Link, { to: path }, children)));
    }
};
//# sourceMappingURL=BreadcrumbItem.js.map